import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../view/Home.vue'
import Login from '../view/Login.vue'

Vue.use(VueRouter)



const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { hideNavigation: true }
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/organisasi',
  //   name: 'Organisasi',
  //   component: () => import('../view/StrukturOrganisasi.vue')
  // },
  // {
  //   path: '/organisasi-Form/:id',
  //   name: 'OrganisasiForm',
  //   component: () => import('../view/StrukturOrganisasiForm.vue')
  // },
  // {
    {
      path: '/agenda-perindo',
      name: 'PostAgenda',
      component: () => import('../view/PostAgenda.vue')
    },
    {
      path: '/agenda-Form/:id',
      name: 'PostAgendaForm',
      component: () => import('../view/PostAgendaForm.vue')
    },
  {
    path: '/aspirasi-perindo',
    name: 'AspirasiPerindo',
    component: () => import('../view/Aspirasi.vue')
  },
  {
    path: '/aspirasi-Form/:id',
    name: 'AspirasiFormPerindo',
    component: () => import('../view/AspirasiPerindoForm.vue')
  },
  {
    path: '/galeri-perindo',
    name: 'GaleriPerindo',
    component: () => import('../view/GaleriPerindo.vue')
  },
  {
    path: '/galeri-Form/:id',
    name: 'GaleriPerindoForm',
    component: () => import('../view/GaleriPerindoForm.vue')
  },
  {
    path: '/berita-perindo',
    name: 'BeritaPerindo',
    component: () => import('../view/BeritaPerindo.vue')
  },
  {
    path: '/berita-perindo/form/:id',
    name: 'BeritaPerindoForm',
    component: () => import('../view/BeritaPerindoForm.vue')
  },
  {
    path: '/dpw',
    name: 'DPW',
    component: () => import('../view/Dpw.vue')
  },
  {
    path: '/dpw-form/:id',
    name: 'DPWForm',
    component: () => import('../view/DpwForm.vue')
  },
  {
    path: '/dpd',
    name: 'DPD',
    component: () => import('../view/Dpd.vue')
  },
  {
    path: '/dpd-form/:id',
    name: 'DPDForm',
    component: () => import('../view/DpdForm.vue')
  },
  {
    path: '/dpp',
    name: 'DPP',
    component: () => import('../view/Dpp.vue')
  },
  {
    path: '/sayap-perindo',
    name: 'SayapPerindo',
    component: () => import('../view/SayapPerindo.vue')
  },
  {
    path: '/sayap-Form/:id',
    name: 'SayapPerindoForm',
    component: () => import('../view/SayapPerindoForm.vue')
  },
  {
    path: '/view-category/:type',
    name: 'ViewCategory',
    component: () => import('../components/ViewCategory.vue')
  },
  {
    path: '/form-category/:type/:id',
    name: 'FormCategory',
    component: () => import('../components/FormCategory.vue')
  },
  {
    path: '/bagian-perindo',
    name: 'BagianPerindo',
    component: () => import('../view/BagianPerindo.vue')
  },
  {
    path: '/bagian-Form/:id',
    name: 'BagianPerindoForm',
    component: () => import('../view/BagianPerindoForm.vue')
  },
  {
    path: '/restore/:type',
    name: 'RestorePost',
    component: () => import('../view/RestorePost.vue')
  },
  {
    path: '/document-perindo',
    name: 'DocumentPerindo',
    component: () => import('../view/Document.vue')
  },
  {
    path: '/document-Form/:id',
    name: 'DocumentPerindoForm',
    component: () => import('../view/DocumentForm.vue')
  },
  {
    path: '/member-report',
    name: 'MemberReport',
    component: () => import('../view/Member.vue')
  },
  {
    path: '/tentang-galeri',
    name: 'TentangGaleri',
    component: () => import('../view/TentangGaleri.vue')
  },
  {
    path: '/tentangGaleri-Form/:id',
    name: 'TentangGaleriForm',
    component: () => import('../view/TentangGaleriForm.vue')
  },
  {
    path: '/tentang-visi-misi',
    name: 'TentangVisiMisi',
    component: () => import('../view/TentangVisiMisi.vue')
  },
  {
    path: '/ketua-umum',
    name: 'TentangKetu',
    component: () => import('../view/TentangKetuaUmum.vue')
  },
  {
    path: '/filosofi-logo',
    name: 'TentangLogo',
    component: () => import('../view/TentangLogo.vue')
  },
  {
    path: '/pemilu-periode',
    name: 'TentangPeriode',
    component: () => import('../view/TentangPeriode.vue')
  }
]

const router = new VueRouter({
  // mode: "history",
  routes
})

export default router
